import React, { useEffect, useState } from "react";
import { getResDataFirebase } from "../../Utils/firebaseResearch";
import { useLocation } from "react-router-dom";

export const UserAnalysis = () => {
  const { state } = useLocation();
  const [resData, setResData] = useState([]);
  const [wordNameList, setWordNameList] = useState([]);
  const [showDetails, setShowDetails] = useState(true);

  useEffect(() => {
    let newArr = [];
    getResDataFirebase().then(function (result) {
      setResData(result);
      newArr = result.filter((u) => u.id === state.userId);
      setWordNameList(newArr[0].WordVal);
    });
  }, []);

  if (showDetails) {
    return (
      <div>
        <h1>Data Analysis {state.userId}</h1>
        <button
          className="defaultButton"
          onClick={() => setShowDetails(!showDetails)}
        >
          show details
        </button>
        {wordNameList.map((w, i) => (
          <div key={i}>
            <strong>{w.word}</strong>
            <br />
            Valence: {w.valence}
            <br />
            Reaction Time:{" "}
            {(Math.round((w.reactionTime / 1000) * 100) / 100).toFixed(2)}
          </div>
        ))}
      </div>
    );
  } else {
    return (
      <div>
        <h1>Data Analysis {state.userId}</h1>
        <button
          className="defaultButton"
          onClick={() => setShowDetails(!showDetails)}
        >
          show details
        </button>
        {wordNameList.map((w, i) => (
          <div key={i}>
            <strong>{w.word}</strong>
          </div>
        ))}
      </div>
    );
  }
};
